$(document).on('click', '.js-load-more', function() {
    var $this =$(this),totalPages = parseInt($('[data-total-pages]').val()),currentPage = parseInt($('[data-current-page]').val());
    $this.attr('disabled', true);
    $this.find('[loader]').removeClass('hide');
    currentPage = currentPage+1;
    var nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPage);
    $('[data-current-page]').val(currentPage);
    $.ajax({
      url: nextUrl,
      type: 'GET',
      dataType: 'html',
      success: function(responseHTML){
        $('#product-grid').append($(responseHTML).find('#product-grid').html());
      },
      complete: function() {
        if(currentPage <= totalPages) {
           $this.attr('disabled', false); 
          $this.find('[load-more-text]').removeClass('hide');    
          $this.find('[loader]').addClass('hide');
        } 
        if(currentPage == totalPages) {                
           $this.addClass('hidden');
        }
      }
    })
  });